function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import findIndex from 'lodash/findIndex';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    dataSources: [],
    connectedDataSources: null,
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = null) {
    switch(action.type){
        case actionTypes.FETCH_DATA_SOURCES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_DATA_SOURCES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_DATA_SOURCES)
                });
            }
        case actionTypes.FETCH_DATA_SOURCES_SUCCESS:
            {
                const { dataSources } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    dataSources,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_DATA_SOURCES)
                });
            }
        case actionTypes.FETCH_DATA_SOURCES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_DATA_SOURCES),
                    errors: registerAction(state.errors, actionTypes.FETCH_DATA_SOURCES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CONNECT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CONNECT),
                    errors: unregisterAction(state.errors, actionTypes.CONNECT)
                });
            }
        case actionTypes.CONNECT_SUCCESS:
            {
                const { connectedDataSource } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    connectedDataSources: [
                        ...state.connectedDataSources,
                        connectedDataSource
                    ],
                    sending: unregisterAction(state.sending, actionTypes.CONNECT)
                });
            }
        case actionTypes.CONNECT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CONNECT),
                    errors: registerAction(state.errors, actionTypes.CONNECT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        // case actionTypes.DISCONNECT: {
        //   return {
        //     ...state,
        //     sending: registerAction(state.sending, actionTypes.DISCONNECT),
        //     errors : unregisterAction(state.errors, actionTypes.DISCONNECT),
        //   };
        // }
        // case actionTypes.DISCONNECT_SUCCESS: {
        //   const { accountExternalDataSourceId } = action.payload;
        //   return {
        //     ...state,
        //     connectedDataSources: reject(state.connectedDataSources, { accountExternalDataSourceId }),
        //     sending             : unregisterAction(state.sending, actionTypes.DISCONNECT),
        //   };
        // }
        // case actionTypes.DISCONNECT_ERROR: {
        //   return {
        //     ...state,
        //     sending: unregisterAction(state.sending, actionTypes.DISCONNECT),
        //     errors : registerAction(state.errors, actionTypes.DISCONNECT),
        //   };
        // }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CONNECTED_DATA_SOURCES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CONNECTED_DATA_SOURCES),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CONNECTED_DATA_SOURCES)
                });
            }
        case actionTypes.FETCH_CONNECTED_DATA_SOURCES_SUCCESS:
            {
                const { connectedDataSources } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    connectedDataSources,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CONNECTED_DATA_SOURCES)
                });
            }
        case actionTypes.FETCH_CONNECTED_DATA_SOURCES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CONNECTED_DATA_SOURCES),
                    errors: registerAction(state.errors, actionTypes.FETCH_CONNECTED_DATA_SOURCES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_DATA_SOURCE_EXCHANGE_TOKEN_SUCCESS:
            {
                const { externalDataSourceId, encryptedDataSourceExchangeToken } = action.payload;
                const connectedDataSources = [
                    ...state.connectedDataSources
                ];
                const idx = findIndex(connectedDataSources, {
                    externalDataSourceId
                });
                if (idx < 0) {
                    return state;
                }
                connectedDataSources[idx] = _object_spread_props(_object_spread({}, connectedDataSources[idx]), {
                    encryptedDataSourceExchangeToken
                });
                return _object_spread_props(_object_spread({}, state), {
                    connectedDataSources
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SYNC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SYNC),
                    errors: unregisterAction(state.errors, actionTypes.SYNC)
                });
            }
        case actionTypes.SYNC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SYNC)
                });
            }
        case actionTypes.SYNC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SYNC),
                    errors: registerAction(state.errors, actionTypes.SYNC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_READINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.STORE_READINGS),
                    errors: unregisterAction(state.errors, actionTypes.STORE_READINGS)
                });
            }
        case actionTypes.STORE_READINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_READINGS)
                });
            }
        case actionTypes.STORE_READINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_READINGS),
                    errors: registerAction(state.errors, actionTypes.STORE_READINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        // TODO: Remove if confirmed
        // case actionTypes.STORE_HEALTH_DATA: {
        //   return {
        //     ...state,
        //     sending: registerAction(state.sending, actionTypes.STORE_HEALTH_DATA),
        //     errors : unregisterAction(state.errors, actionTypes.STORE_HEALTH_DATA),
        //   };
        // }
        // case actionTypes.STORE_HEALTH_DATA_SUCCESS: {
        //   return {
        //     ...state,
        //     sending: unregisterAction(state.sending, actionTypes.STORE_HEALTH_DATA),
        //   };
        // }
        // case actionTypes.STORE_HEALTH_DATA_ERROR: {
        //   return {
        //     ...state,
        //     sending: unregisterAction(state.sending, actionTypes.STORE_HEALTH_DATA),
        //     errors : registerAction(state.errors, actionTypes.STORE_HEALTH_DATA),
        //   };
        // }
        //------------------------------------------------------------------------------------------------------------------
        default:
            return state;
    }
}
